<template>
  <layout-main-inner :title="$route.meta.name">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.vendorName"
          clearable
          placeholder="请输入企业名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="企业名称"
          min-width="180"
          prop="vendorName"> </el-table-column>
        <el-table-column
          label="企业类型"
          min-width="90"
          prop="vendorAddress">
          <template slot-scope="{ row }">
            {{ row.scmOpenFlag === 1 ? '供应链' : '非供应链' }}
          </template>
        </el-table-column>
        <el-table-column
          label="证书数量"
          min-width="90"
          prop="certificateCount"> </el-table-column>
        <el-table-column
          v-if="!permission.LVL2"
          label="所属机构"
          prop="sgsName"
          min-width="120"></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="105">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateitem(row)"> {{ permission.LVL2 ? '编辑证书' : '查看证书' }}  </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">  </el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'VendorCertificate',
  components: { },
  data() {
    return {
      loading: true,
      totalApplys: 0,
      list: [],
      totalNum: 0,
      deleteable: process.env.NODE_ENV,
      surveyFormFile: '',
      download: '',
      config: { pageNum: 1, pageSize: 10, vendorName: '', appraisalOpenFlag: 0, memberFlag: 1 }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    updateitem(row) {
      const { vendorName, vendorId } = row
      this.$router.push({ path: '/certificate', query: { vendorName, vendorId }})
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getvendors', {
        payload: { ...this.config },
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
